import { render } from "./ShowDiffCarInfo.vue?vue&type=template&id=9ebdf538&scoped=true"
import script from "./ShowDiffCarInfo.vue?vue&type=script&lang=js"
export * from "./ShowDiffCarInfo.vue?vue&type=script&lang=js"

import "./ShowDiffCarInfo.vue?vue&type=style&index=0&id=9ebdf538&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ebdf538"]])

export default __exports__